import React from 'react'

import { Dashboard } from '@components/common/Dashboard/Dashboard'
import { OrderedList } from '@components/common/OrderedList'
import { PageLayout } from '@components/common/PageLayout'
import { DashboardBackButton } from '@components/utils'
import { HeadContent, Skeleton } from '@fourthwall/components'
import { routing } from '@utils/routing'

import { ConnectBar } from '../../components/ConnectBar/ConnectBar'
import { useDiscord } from './hooks/useDiscord'

export const AppsDiscord = () => {
  const { discord } = useDiscord()

  return (
    <>
      <HeadContent title="Members-only Discord server" />
      <PageLayout size="tiny">
        <Dashboard.Section
          name="Members-only Discord server"
          topContent={<DashboardBackButton label="Apps" to={routing.apps.self} />}
          bottomContent={
            <div style={{ lineHeight: 1.5 }}>
              <p>Allows you to offer access to your own Discord server directly with your fans.</p>
              <OrderedList>
                <OrderedList.Item>Connect your Discord account.</OrderedList.Item>
                <OrderedList.Item>
                  Add "Discord” perk to your tiers on Perks &amp; tiers tab inside Memberships
                  settings.
                </OrderedList.Item>
              </OrderedList>
            </div>
          }
        >
          <div style={{ marginTop: 16 - 24, marginBottom: 40 }}>
            {discord.connectBar ? (
              <ConnectBar {...discord.connectBar} />
            ) : (
              <Skeleton>
                <Skeleton.Shape height={64} />
              </Skeleton>
            )}
          </div>
        </Dashboard.Section>
      </PageLayout>
    </>
  )
}
